import { defineMessages } from 'react-intl-next';

export default defineMessages({
    helpCenterTitle: {
        defaultMessage: '{helpCenterTitle} - Jira Service Management',
        description: 'Page title for help center landing page',
        id: 'sd.jsm.customerview.helpcenter.page.title',
    },
});
